import { AnnotationHandler } from 'owa-editor-augloop-plugin';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "EditorProofingHandler" */ './lazyIndex')
);

export let lazyGetHandler = new LazyImport(lazyModule, m => m.getHandler);

export async function getAnnotationHandlerAsync(): Promise<AnnotationHandler> {
    const getHandler = await lazyGetHandler.import();
    return getHandler();
}
